import { useCallback } from 'react';
import { API_ENDPOINTS } from '../config/api/apiCall';
import { RequestIndentCRUD } from '../services/requestIndentService';

const usePurchasedIndentCRUD = (callMessage) => {
    const processIndent = useCallback(async (selectedMode, editPurchaseIndentID, requestBody) => {
        try {
            const apiEndpoint = API_ENDPOINTS.PURCHASE_INDENT_CRUD_PROCESS;

            const successMessage = selectedMode === 0
                ? (editPurchaseIndentID !== 0 
                    ? 'Purchased indent updated Successfully' 
                    : 'New Purchased indent Created Successfully')
                : 'New Purchased indent Created Successfully';

            // Await the API response
            const data = await RequestIndentCRUD(apiEndpoint, requestBody);
            
            if (data?.length > 0) {
                callMessage('info', successMessage, 'info');
            } else {
                callMessage('error', 'No data received from API', 'Error');
            }
        } catch (error) {
            callMessage('error', error.message || 'An unexpected error occurred', 'Error');
        }
    }, [callMessage]);

    return { processIndent };
};

export default usePurchasedIndentCRUD;

